<mat-form-field *ngIf="ngControl.control as control">
  <mat-label> {{ label }}{{ isFieldRequired(control) }}</mat-label>
  <input
    matInput
    [formControl]="dateControl"
    [owlDateTime]="datetimePicker"
    [owlDateTimeTrigger]="datetimePicker"
    [min]="min"
    [max]="max"
    [readonly]="true"
    [attr.test-id]="testId"
    [ngClass]="{ prefilled: disabled }"
  />
  <ui-svg-icon
    [name]="fontIcon"
    [class.calendar-icon__disabled]="isDisabled"
    class="tw-cursor-pointer"
    matSuffix
    (click)="datetimePicker.open()"
  ></ui-svg-icon>
  <ui-svg-icon
    *ngIf="showWarningIcon"
    [name]="iconNames.AlertWarningFilled"
    class="tw-cursor-pointer tw-text-bosch-yellow-80 warning-icon tw-pl-2"
    [matTooltip]="warningTooltip"
    matSuffix
  ></ui-svg-icon>
  <owl-date-time
    #datetimePicker
    [pickerType]="pickerType"
    [startAt]="startTime"
    [panelClass]="[ isHourOnlyMode ? 'hour-only-picker': '', testId + 'Picker']"
    [disabled]="disabled"
    (dateSelected)="onDateValueChanged($event)"
  ></owl-date-time>

  <mat-hint *ngIf="timezoneText" class="timezone-info-text">{{ timezoneText }}</mat-hint>
  <mat-error *ngIf="control?.invalid && control.value"
    >{{ errorMessage || 'common.validation.error.required' | translate }}
  </mat-error>
  <mat-error *ngIf="control?.invalid && !control.value"
    >{{ 'common.validation.error.required' | translate }}
  </mat-error>
</mat-form-field>
